import Chaplin from 'chaplin';

const Location = Chaplin.Model.extend({});

export default Location;
